import React from 'react';
import {useNavigate} from 'react-router-dom';

const Service = ({service}) => {
    let navigate = useNavigate();
    const {id, name, imageBase64, imageTag} = service;
    const handleClick = (serviceID) => {
        navigate(`/services/${serviceID}`);
    }
    return (
        <div onClick={() => handleClick(id)} className="custom-service-card">
            <div className="custom-service-card-header">
                <img src={`data:image/jpg;base64,${imageBase64}`} alt={imageTag}/>
            </div>
            <div className="custom-service-card-body">
                <span className="service-name">{name}</span>
            </div>
        </div>
    );
};

export default Service;
